const uniqueID =  () => {
  const id = `${String.fromCharCode(64 + Math.floor((Math.random() * 26)+1))}-${Math.floor(Math.random() * 100)}-${Date.now()}`;
  return id;
}
export default uniqueID;